// import { Component, OnInit } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Component, ViewChild, AfterViewInit, NgModule, Inject, OnInit} from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTable } from '@angular/material/table';
import {merge, Observable, of as observableOf} from 'rxjs';
import {catchError, map, startWith, switchMap} from 'rxjs/operators';
import { BrowserModule } from '@angular/platform-browser';
import { HttpService } from '../../http.service';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { MatSnackBar} from '@angular/material/snack-bar';
import { AuthenticationService } from '../../_services';
import { EntradaService } from '../../_services';
import { first } from 'rxjs/operators';
import {MatButtonModule} from '@angular/material/button';
import { InvoiceService } from '../../_services';
import {MatDivider} from '@angular/material/divider';
import { ShippingService } from '../../_services';
import { ClienteService } from '../../_services';
import { UserService } from '../../_services';
import { AccountService } from 'src/app/_services/account.service';
import { CredentialService } from '../../_services/credentia.service';
import {environment} from "../../../environments/environment";

@Component({
  selector: 'app-accounts',
  templateUrl: './accounts.component.html',
  styleUrls: ['./accounts.component.scss']
})
export class AccountsComponent implements OnInit {

  constructor(
    private authenticationService: AuthenticationService

  ) { }
  current_user: any
  ngOnInit() {
    this.asignarDatos();
  }
  asignarDatos(){
    this.current_user = this.authenticationService.currentUserValue

  }
  validar_roles(clave_modulo){
    return this.authenticationService.validar_roles(clave_modulo,this.current_user.permisos);
  }

}


@Component({
  selector: 'accounts-tab-1',
  templateUrl: './accounts-tab-1.html',
  styleUrls: ['./accounts.component.scss']

})
export class AccountsTab1 implements AfterViewInit {

  displayedColumns: string[] = [
                                  'id',
                                  //'pagado',
                                  'fecha_emision',
                                  'fecha_vencimiento',
                                  'monto_base',
                                  'monto_iva',
                                  'monto_total',
                                  'status',
                                  'descargar'
                                ];
  entradaDatabase: EntradaDatabase | null;
  data: EntradaIssue[] = [];

  resultsLength = 0;
  isLoadingResults = true;
  isRateLimitReached = false;
  guiaForm: FormGroup;
  keywords = "";

  correo_seller: string;
  correo_seller_bd: string;
  correo_cambiado: boolean = false;
  nombre_tienda: string;
  nombre_tienda_bd: string;
  nombre_cambiado: boolean = false;
  confirmacion_password =""
  current_user: any;
  correo_contacto_bd: string;
  correo_contacto: string;
  telefono_contacto_bd: string;
  telefono_contacto: string;
  persona_contacto_bd: string;
  persona_contacto: string;
  rfc_bd: string;
  rfc: string;
  rfc_cambiado: boolean = false;
  contacto_cambiado: boolean = false;
  password_cambiado: boolean = false
  usuario: any;

  passwordForm: FormGroup;
  form_password: []
  nuevo_password: any = {};

  clave_sat_cambiado: boolean = false
  clave_sat: string;
  claves_sat: ClaveSat[] = [];
  buscar_clave_sat: FormControl;

  constructor(
      private accountService: AccountService,
      private formBuilder: FormBuilder,
      private _httpClient: HttpClient,
      public dialog: MatDialog,
      private invoiceService: InvoiceService,
      private snackBar: MatSnackBar,
      private authenticationService: AuthenticationService,
      private credentialService: CredentialService
  ) { }

  @ViewChild(MatPaginator, {static: false}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: false}) sort: MatSort;

  ngOnInit() {
    this.asignarDatos()

    this.passwordForm = this.formBuilder.group({
        old_password: ['', Validators.required],
        password: ['', [Validators.required, Validators.pattern(
          /(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[@$!%*#?&^_-]).{8,}/
        )]],
        password_conf: ['', [Validators.required, Validators.pattern(
          /(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[@$!%*#?&^_-]).{8,}/
        )]],
    });

    this.buscar_clave_sat = new FormControl(this.clave_sat,[
      Validators.required,
    ]);
  }

  displayFn(subject){
    if(subject){
      return subject.clave_prod_serv + " - " + subject.descripcion;
    }else{
      return undefined;
    }
  }

  cargarClavesSat(){

    if(this.clave_sat != this.buscar_clave_sat.value){
      this.clave_sat_cambiado = true;
    }else{
      this.clave_sat_cambiado = false;
    }

    this.accountService.consultarClavesSat(this.buscar_clave_sat.value)
    .pipe(first())
    .subscribe(
      data => {
          if(data.status == 200){
            this.claves_sat = data.body.claves_sat;
          }
        },
      error => {
    });
  }

  guardarClaveSat(){

    if(this.buscar_clave_sat.invalid){
      return;
    }

    var elItem = this.buscar_clave_sat.value;
    if(!elItem){
      return;
    }

    if(!(typeof elItem === 'object' && elItem !== null)){
      this.snackBar.open("Debes seleccionar una Clave SAT de la lista", "OK", {
        duration: 5000,
      });
      return;
    }

    this.accountService.cambiarClaveSat(this.buscar_clave_sat.value.clave_prod_serv)
    .pipe(first())
    .subscribe(
      data => {
          if(data.result == 200){
            this.snackBar.open("Clave SAT Actualizada", "OK", {
              duration: 3500,
            });

            this.clave_sat_cambiado = false;
            this.consultarDatos();
          }else{
            this.snackBar.open(data.body.messages, "OK", {
              duration: 3500,
            });
          }
        },
      error => {
    });

  }

  asignarDatos(){
    this.current_user = this.authenticationService.currentUserValue
    this.correo_seller_bd = this.current_user.username
    this.correo_seller = this.current_user.username

    this.nombre_tienda_bd = this.current_user.seller_alias
    this.nombre_tienda = this.current_user.seller_alias

    this.persona_contacto = this.current_user.persona_contacto
    this.persona_contacto_bd = this.current_user.persona_contacto
    this.correo_contacto = this.current_user.correo_contacto
    this.correo_contacto_bd = this.current_user.correo_contacto
    this.telefono_contacto = this.current_user.telefono_contacto
    this.telefono_contacto_bd = this.current_user.telefono_contacto

    this.rfc = this.current_user.rfc
    this.rfc_bd = this.current_user.rfc

    this.accountService.consultarClaveSat(this.current_user.clave_sat)
    .pipe(first())
    .subscribe(
      data => {
          if(data.status == 200){
            if (data.body.message == 'OK'){
              this.buscar_clave_sat.setValue(data.body.clave_sat);
            }
          }
        },
      error => {
    });

  }
  consultarDatos(){
    // console.log("entramos en consultarDatos");
    this.authenticationService.consultarUser()
    .pipe(first())
    .subscribe(
      data => {
        // console.log("regresamos de consultar user")
        // console.log(data)
        this.current_user = this.authenticationService.currentUserValue
        // console.log(this.current_user)
      },
      error => {
       // console.log("error 143")
   });

  }

  validar_roles(clave_modulo){
    return this.authenticationService.validar_roles(clave_modulo,this.current_user.permisos);
  }

  ngAfterViewInit() {
    this.entradaDatabase = new EntradaDatabase(this._httpClient);
    this.asignarDatos()
  }



  setClasses() {
    let myClasses = {
    }
    return  myClasses
  }


  //  PARA DIALOGO GUIAS
  openDialog(entrada_token) {
    // console.log("Entro a dialog guia")

    //// console.log(correo)
    const dialogRef = this.dialog.open(DialogAccount ,{width:'450px', height: 'auto', data: {token: entrada_token}});

    dialogRef.afterClosed().subscribe(result => {
      // console.log("Cerramos el dialog");
      //this.hacerTabla(this.keywords);
    });
  }

  cambioCorreo(){
    // console.log("cambiaste el correo")
    if(this.correo_seller != this.correo_seller_bd){
      this.correo_cambiado = true
    }else{
      this.correo_cambiado = false
    }
    // console.log("el nombre esta cambiado " + this.correo_cambiado)
  }

  cambioAlias(){
    // console.log("cambiaste el correo")
    if(this.nombre_tienda != this.nombre_tienda_bd){
      this.nombre_cambiado = true
    }else{
      this.nombre_cambiado = false
    }
    // console.log("el nombre esta cambiado " + this.nombre_cambiado)
  }

  cambioContacto(){
    // console.log("cambiaste el contacto")
    if(this.correo_contacto != this.correo_contacto_bd || this.persona_contacto != this.persona_contacto_bd || this.telefono_contacto != this.telefono_contacto_bd){
      this.contacto_cambiado = true
    }else{
      this.contacto_cambiado = false
    }
    // console.log("el contacto esta cambiado " + this.contacto_cambiado)
  }

  cambioPassword(){
    if(this.passwordForm.value.password != this.passwordForm.value.password_conf){
      this.password_cambiado = false
    }else if(this.passwordForm.value.password != null && this.passwordForm.value.password != null && this.passwordForm.value.password == this.passwordForm.value.password_conf && this.passwordForm.value.old_password != null){
      this.password_cambiado = true
    }else {
      this.password_cambiado = false
    }
  }

  cambioRFC() {
    if(this.rfc != this.rfc_bd){
      this.rfc_cambiado = true
    }else{
      this.rfc_cambiado = false
    }
  }

  guardarCorreo(){
    // console.log("le diste a guardar correo")
    // console.log("se manda a la api")
    this.authenticationService.cambiarCorreo(this.correo_seller)
    .pipe(first())
    .subscribe(
      data => {
        // console.log("consultar Orden es");
        // console.log(data);
        if(data.result == 200){
          this.correo_seller_bd = this.correo_seller
          this.snackBar.open("Correo actualizado", "OK", {
              duration: 3500,
            });
          this.cambioCorreo()
          this.consultarDatos()
        }
      },
      error => {
    });


    // cableado, en realidad va a tomar el que mande la api

  }

  guardarTienda(){
    // console.log("le diste a guardar tienda")
    // console.log("se manda a la api")
    this.authenticationService.cambiarAlias(this.nombre_tienda)
    .pipe(first())
    .subscribe(
      data => {
        // console.log("consultar Orden es");
        // console.log(data);
        if(data.result == 200){
          this.nombre_tienda_bd = this.nombre_tienda
          this.snackBar.open("Nombre de la Tienda actualizado", "OK", {
              duration: 3500,
            });
          this.cambioAlias()
          this.consultarDatos()
        }
      },
      error => {
    });
    // cableado, en realidad va a tomar el que mande la api

  }

  guardarContacto(){
    // console.log("le diste a guardar contacto")
    // console.log("se manda a la api")
    this.authenticationService.cambiarContacto(this.persona_contacto, this.correo_contacto, this.telefono_contacto)
    .pipe(first())
    .subscribe(
      data => {
        // console.log("consultar Orden es");
        // console.log(data);
        if(data.result == 200){
          this.persona_contacto_bd = this.persona_contacto
          this.correo_contacto_bd = this.correo_contacto
          this.telefono_contacto_bd = this.telefono_contacto
          this.snackBar.open("Info de contacto actualizada", "OK", {
              duration: 3500,
            });
          this.cambioContacto()
          this.consultarDatos()
          // reset inputs de password
        }
      },
      error => {
    });
  }

  guardarPassword(){
    // console.log("le diste a guardar contacto")
    // console.log("se manda a la api")

    if (this.passwordForm.valid){
      this.authenticationService.cambiarPasswordLogeado(this.passwordForm.value.old_password, this.passwordForm.value.password)
      .pipe(first())
      .subscribe(
        data => {
          // console.log("consultar Orden es");
          // console.log(data);
          if(data.result == 200){
            this.snackBar.open("Contraseña actualizada", "OK", {
                duration: 3500,
              });
            // reset inputs de password
          }else{
            this.snackBar.open(data.messages, "OK", {
              duration: 3500,
            });
          }
        },
        error => {
      });
    }
  }

  guardarRFC(){
    let rfc = this.rfc ? this.rfc : null
    this.authenticationService.cambiarRFC(rfc)
    .pipe(first())
    .subscribe(
      data => {
        if(data.result == 200){
          this.rfc_bd = this.rfc
          this.snackBar.open("RFC actualizada", "OK", {
              duration: 3500,
            });
          this.cambioRFC()
          this.consultarDatos()
        }
      },
      error => {
    });
  }

}

export interface EntradabApi {
  items: EntradaIssue[];
  total_count: number;
}

export interface EntradaIssue {
  created_at: string;
  number: string;
  state: string;
  title: string;
}

/** An example database that the data source uses to retrieve data for the table. */
export class EntradaDatabase {
  constructor(private _httpClient: HttpClient) {}

  getRepoIssues(sort: string, order: string, page: number, filtro: string): Observable<EntradabApi> {
    // console.log(sort)
    // console.log(order)
    // console.log(page)
     const href = `${environment.apiUrl}/seller_shipping_methods/query_ssm.json`;
    // const href = 'http://localhost:3000/rmsfe/query_entradas.json';
    const requestUrl =
        `${href}?sort=${sort}&order=${order}&page=${page + 1}&keywords=${filtro}`;

    return this._httpClient.get<EntradabApi>(requestUrl);
  }

  getListCli(sort: string, order: string, page: number, filtro: string): Observable<EntradabApi> {
     const href = `${environment.apiUrl}/rmsfe/query_list_cli_api.json`;
    const requestUrl =
        `${href}?sort=${sort}&order=${order}&page=${page + 1}&keywords=${filtro}`;

    return this._httpClient.get<EntradabApi>(requestUrl);
  }

    getListUser(sort: string, order: string, page: number, filtro: string): Observable<EntradabApi> {
      const href = `${environment.apiUrl}/rmsfe/query_list_user_api.json`;
      const requestUrl =
        `${href}?sort=${sort}&order=${order}&page=${page + 1}&keywords=${filtro}`;

      return this._httpClient.get<EntradabApi>(requestUrl);
    }

    getListRole(sort: string, order: string, page: number, filtro: string): Observable<EntradabApi> {
      const href = `${environment.apiUrl}/rmsfe/query_list_role_api.json`;
      const requestUrl =
        `${href}?sort=${sort}&order=${order}&page=${page + 1}&keywords=${filtro}`;

      return this._httpClient.get<EntradabApi>(requestUrl);
    }

    getListBoxes(sort: string, order: string, page: number, filtro: string): Observable<EntradabApi> {
      const href = `${environment.apiUrl}/rmsfe/query_list_boxes_api.json`;
      const requestUrl =
        `${href}?sort=${sort}&order=${order}&page=${page + 1}&keywords=${filtro}`;

      return this._httpClient.get<EntradabApi>(requestUrl);
    }

    getListCredentials(sort: string, order: string, page: number, filtro: string): Observable<EntradabApi> {
      const href = `${environment.apiUrl}/rmsfe/get_seller_credentials_api.json`;
     const requestUrl =
         `${href}?sort=${sort}&order=${order}&page=${page + 1}&keywords=${filtro}`;
 
     return this._httpClient.get<EntradabApi>(requestUrl);
   }
}



@Component({
  selector: 'accounts-tab-2',
  templateUrl: './accounts-tab-2.html',
  styleUrls: ['./accounts.component.scss']

})
export class AccountsTab2 implements OnInit {

  current_user: any;
  fulfillment_id: any;
  displayedColumns: string[] = [
                                  'id',
                                  'fecha_emision',
                                  'fecha_vencimiento',
                                  'monto_base',
                                ];
  entradaDatabase: EntradaDatabase | null;
  data: EntradaIssue[] = [];

  displayedColumnsBoxes: string[] = [
                                    'tipo_empaque',
                                    'nombre',
                                    'codigo',
                                    'alto',
                                    'largo',
                                    'ancho',
                                    'peso',
                                    'editar',
                                    'eliminar',
                                  ];
  entradaBoxesDatabase: EntradaDatabase | null;
  dataBoxes: EntradaIssue[] = [];


  resultsLength = 0;
  resultsBoxesLength = 0;
  isLoadingResults = true;
  isRateLimitReached = false;
  spinner_table = false;
  profileForm = new FormGroup({
    firstName: new FormControl(''),
    lastName: new FormControl(''),
    toppings: new FormControl('',[ Validators.required,]),
    description: new FormControl('',[ Validators.required,]),
    tipo_envio: new FormControl('',[ Validators.required,])
  });
  toppingList: string[] = [];
  enviosList = [{'name': 'Económico', 'value': 'economico'}, {'name': 'Día Siguiente', 'value': 'dia_siguiente'}, {'name': 'Mismo Día', 'value': 'mismo_dia'}, {'name': 'CoD Día Siguiente', 'value': 'CoD_next_day'}, {'name': 'CoD Mismo Día', 'value': 'CoD_same_day'}];
  keywords = "";
  datos_envio: object;

  constructor(
      private formBuilder: FormBuilder,
      private _httpClient: HttpClient,
      public dialog: MatDialog,
      private clienteService: ClienteService,
      private shippingService: ShippingService,
      private snackBar: MatSnackBar,
      private authenticationService: AuthenticationService
  ) { }

  @ViewChild(MatPaginator, {static: false}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: false}) sort: MatSort;

  @ViewChild(MatPaginator, {static: false}) paginatorBoxes: MatPaginator;
  @ViewChild(MatSort, {static: false}) sortBoxes: MatSort;

  ngAfterViewInit() {

    this.entradaDatabase = new EntradaDatabase(this._httpClient);

    // console.log("las keywords iniciales son " + this.keywords)
     this.hacerTabla(this.keywords);


    this.entradaBoxesDatabase = new EntradaDatabase(this._httpClient);

    // console.log("las keywords iniciales son " + this.keywords)
     this.hacerTablaBoxes(this.keywords);
  }

  ngOnInit() {
    // DEPENDIENDO DEL FULFILLMENT SE MUESTRAN LAS OPCIONES DE PAQUETERÍAS
    this.asignarDatos();
    this.fulfillment_id = this.current_user.fulfillment_id
  }

  updateToppingList(){
    let tipo_envio = this.profileForm.value.tipo_envio;
    switch (tipo_envio) {
      case 'CoD_next_day': // Cash On Delivery
        this.toppingList = ['Mas económico'];
      break;
      case 'CoD_same_day': // Cash On Delivery
        this.toppingList = ['Mas económico'];
      break;
      case 'mismo_dia':
        this.toppingList = ['Mas económico', '99m'];
      break;
      case 'dia_siguiente':
        this.toppingList = ['Mas económico', 'Estafeta', 'FedEx', 'Internacional', '99m', 'tiui'];
      break;
      case 'economico':
        this.toppingList = ['Mas económico', 'AMPM','Estafeta', 'FedEx', 'Internacional', 'Paquetexpress', '99m', 'tiui'];
      break;

      default:
      break;
    }
  }

  hacerTabla(filtros){
    merge(this.sort.sortChange, this.paginator.page, )
      .pipe(
        startWith({}),
        switchMap(() => {
          this.isLoadingResults = true;
          return this.entradaDatabase!.getRepoIssues(
            this.sort.active, this.sort.direction, this.paginator.pageIndex, filtros);
        }),
        map(data => {
          // Flip flag to show that loading has finished.
          this.isLoadingResults = false;
          this.isRateLimitReached = false;
          this.resultsLength = data.total_count;
          // console.log("vamos en la 72")
          // console.log(data)


          return data.items;
        }),
        catchError(() => {
          this.isLoadingResults = false;
          // Catch if the GitHub API has reached its rate limit. Return empty data.
          this.isRateLimitReached = true;
          return observableOf([]);
        })
      ).subscribe(data => this.data = data);
  }

  hacerTablaBoxes(filtros){
    merge(this.sortBoxes.sortChange, this.paginatorBoxes.page, )
      .pipe(
        startWith({}),
        switchMap(() => {
          this.isLoadingResults = true;
          return this.entradaBoxesDatabase!.getListBoxes(
            this.sortBoxes.active, this.sortBoxes.direction, this.paginatorBoxes.pageIndex, filtros);
        }),
        map(dataBoxes => {
          // Flip flag to show that loading has finished.
          this.isLoadingResults = false;
          this.isRateLimitReached = false;
          this.resultsBoxesLength = dataBoxes.total_count;
          // console.log("vamos en la 72")
          // console.log(data)


          return dataBoxes.items;
        }),
        catchError(() => {
          this.isLoadingResults = false;
          // Catch if the GitHub API has reached its rate limit. Return empty data.
          this.isRateLimitReached = true;
          return observableOf([]);
        })
      ).subscribe(dataBoxes => this.dataBoxes = dataBoxes);
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.keywords = filterValue.trim().toLowerCase();
    // console.log("las keywords son ")
    // console.log(this.keywords)
    // this.hacerTablaInvoices(this.keywords);
  }

  onSubmit(){
    // console.log("entraste en onsubmit ")
    // console.log(this.profileForm.value.description);
    // console.log(this.profileForm.value.tipo_envio);
    // console.log(this.profileForm.value.toppings);
    if(this.profileForm.valid){
      this.datos_envio = {
        name: this.profileForm.value.description,
        speed: this.profileForm.value.tipo_envio,
        carrier_name: this.profileForm.value.toppings
      }

      this.shippingService.crearSsm(this.datos_envio)
      .pipe(first())
      .subscribe(
        data => {
          // console.log("la data es");
          // console.log(data);
          // console.log(data.status)
          this.hacerTabla(this.keywords);
          this.snackBar.open("Metodo de envio agregado correctamente", "OK", {
            duration: 5000,
          });

        },
        error => {
          // console.log("error")
      });
    }else{
      this.snackBar.open("Datos incompletos", "OK", {
        duration: 5000,
      });
    }

  }

  eliminarSsm(ssm_id){
    // console.log("vas a eliminar el ssm con id " + ssm_id);
    this.shippingService.eliminarSsm(ssm_id)
    .pipe(first())
    .subscribe(
      data => {
        // console.log("la data es");
        // console.log(data);
        this.hacerTabla(this.keywords);
        this.snackBar.open("Metodo de envio eliminado correctamente", "OK", {
          duration: 5000,
        });

      },
      error => {
        // console.log("error")
    });
  }

  asignarDatos(){
    this.current_user = this.authenticationService.currentUserValue

  }
  validar_roles(clave_modulo){
    return this.authenticationService.validar_roles(clave_modulo,this.current_user.permisos);
  }

  abrirModalAltaCaja(){
    // this.btn_editar = false;
      const dialogRefCaja = this.dialog.open(DialogAltaBox ,{width:'450px', height: 'auto',disableClose: true});

      dialogRefCaja.afterClosed().subscribe(result => {
        // this.spinner = true;
        this.hacerTablaBoxes(this.keywords);
      });
  }

  openEditCaja(dataBox){
    this.clienteService.consultarCaja(dataBox.id)
    .pipe(first())
    .subscribe(
      data => {
          if(data.status == 200){
            const dialogRef2 = this.dialog.open(DialogAltaBox ,{width:'450px', height: 'auto',disableClose: true, data: {item: data.body.box_customer}});
            dialogRef2.afterClosed().subscribe(result => {
              // this.spinner = true;
              this.hacerTablaBoxes(this.keywords);
            });
          }
        },
      error => {
    });
  }

  confirmarEliminarCaja(box_id){
    const dialogRef5 = this.dialog.open(ClientesDialog5, {width:'450px', height: 'auto',disableClose: true});

    dialogRef5.afterClosed().subscribe(result => {
      if (result == true){
        this.spinner_table = true;
        this.eliminarCaja(box_id);
      }
    });
  }

  eliminarCaja(box_id){
      this.clienteService.eliminarCaja(box_id)
      .pipe(first())
      .subscribe(
        data => {
          if (data["status"] == 200){
            this.hacerTablaBoxes(this.keywords);
          }
          this.spinner_table = false;
          this.snackBar.open(data["message"], "OK", {
            duration: 7500,
          });
        },
        error => {
          this.spinner_table = false;
          this.snackBar.open("Hubo un error al eliminar al cliente", "OK", {
            duration: 7500,
          });
     });
  }

}

@Component({
  selector: 'accounts-tab-4',
  templateUrl: './accounts-tab-4.html',
  styleUrls: ['./accounts.component.scss']

})
export class AccountsTab4 implements OnInit {
  spinner = false;
  displayedColumnsCli: string[] = [
    'nombre',
    'correo',
    'telefono',
    'colonia',
    'ciudad',
    'estado',
    'editar',
    'eliminar'
  ];

  resultsLength      = 0;
  entradaDatabase    : EntradaDatabase | null;
  data               : EntradaIssue[] = [];
  keywords           = "";
  isLoadingResults   = true;
  isRateLimitReached = false;
  spinner_table      = false;
  current_user       : any

  constructor(public dialog: MatDialog,
    private _httpClient: HttpClient,
    private clienteService: ClienteService,
    private snackBar: MatSnackBar,
    private authenticationService: AuthenticationService
    ) { }

  @ViewChild(MatPaginator, {static: false}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: false}) sort: MatSort;

  ngAfterViewInit() {
    this.entradaDatabase = new EntradaDatabase(this._httpClient);
    this.crearTablaCli(this.keywords);
  }

  ngOnInit() {
    this.asignarDatos();
  }
  asignarDatos(){
    this.current_user = this.authenticationService.currentUserValue

  }
  validar_roles(clave_modulo){
    return this.authenticationService.validar_roles(clave_modulo,this.current_user.permisos);
  }

  abrirModalAlta(){
      const dialogRef2 = this.dialog.open(DialogAltaCli ,{width:'450px', height: 'auto',disableClose: true});

      dialogRef2.afterClosed().subscribe(result => {
        this.spinner = true;
        this.crearTablaCli(this.keywords);
      });
  }

  crearTablaCli(filtros){
    merge(this.sort.sortChange, this.paginator.page, )
      .pipe(
        startWith({}),
        switchMap(() => {
          this.isLoadingResults = true;
          return this.entradaDatabase!.getListCli(
            this.sort.active, this.sort.direction, this.paginator.pageIndex, filtros);
        }),
        map(data => {
          // Flip flag to show that loading has finished.
          this.isLoadingResults = false;
          this.isRateLimitReached = false;
          this.resultsLength = data.total_count;
          return data.items;
        }),
        catchError(() => {
          this.isLoadingResults = false;
          this.isRateLimitReached = true;
          return observableOf([]);
        })
      ).subscribe(data => this.data = data);
  }


  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.keywords = filterValue.trim().toLowerCase();
    this.crearTablaCli(this.keywords);
  }

  openEditCli(seller_customer){
    this.clienteService.consultarCliente(seller_customer.id)
    .pipe(first())
    .subscribe(
      data => {
          if(data.status == 200){
            const dialogRef2 = this.dialog.open(DialogAltaCli ,{width:'450px', height: 'auto',disableClose: true, data: {item: data.body.seller_customer}});
            dialogRef2.afterClosed().subscribe(result => {
              this.spinner = true;
              this.crearTablaCli(this.keywords);
            });
          }
        },
      error => {
    });
  }

  confirmarEliminarCliente(seller_customer_id){
    const dialogRef1 = this.dialog.open(ClientesDialog4, {width:'450px', height: 'auto',disableClose: true});

    dialogRef1.afterClosed().subscribe(result => {
      if (result == true){
        this.spinner_table = true;
        this.eliminarCliente(seller_customer_id);
      }
    });
  }

  eliminarCliente(seller_customer_id){
      this.clienteService.eliminarCliente(seller_customer_id)
      .pipe(first())
      .subscribe(
        data => {
          if (data["status"] == 200){
            this.crearTablaCli(this.keywords);
          }
          this.spinner_table = false;
          this.snackBar.open(data["message"], "OK", {
            duration: 7500,
          });
        },
        error => {
          this.spinner_table = false;
          this.snackBar.open("Hubo un error al eliminar al cliente", "OK", {
            duration: 7500,
          });
     });
  }

}

@Component({
  selector: 'dialog-add-cli-tab-2',
  templateUrl: './dialog-add-cli-tab-2.html',
})
export class DialogAltaCli {
  clienteForm: FormGroup;
  formNombre: FormControl;
  formCorreo: FormControl;
  formTelefono: FormControl;
  formCalle: FormControl;
  formNumExterior: FormControl;
  formNumInterior: FormControl;
  formColonia: FormControl;
  formCiudad: FormControl;
  formEstado: FormControl;
  formCodigoPostal: FormControl;
  mensaje_success = false;
  spinner = false;
  error: string;
  loading = false;
  btn_disabled = false;
  datos_envio: object;
  seller_customer_id: string;
  constructor(private formBuilder: FormBuilder,
    public dialogRef: MatDialogRef<DialogAltaCli>,
    private clienteService: ClienteService,
    private snackBar: MatSnackBar,
    @Inject(MAT_DIALOG_DATA) public data: any){
  }

  ngOnInit(){
    this.clienteForm = this.formBuilder.group({ });
    this.formNombre = new FormControl('', [Validators.required]);
    this.formCorreo = new FormControl('', [ Validators.email]);
    this.formTelefono = new FormControl('', [Validators.required]);
    this.formCalle = new FormControl('', [Validators.required]);
    this.formNumExterior = new FormControl('', [Validators.required]);
    this.formNumInterior = new FormControl('', []);
    this.formColonia = new FormControl('', [Validators.required]);
    this.formCiudad = new FormControl('', [Validators.required]);
    this.formEstado = new FormControl('', [Validators.required]);
    this.formCodigoPostal = new FormControl('', [Validators.required, Validators.minLength(5), Validators.maxLength(5)]);

    if(this.data != null){
      this.seller_customer_id = this.data.item.id;
      this.formNombre.setValue(this.data.item.nombre);
      this.formCorreo.setValue(this.data.item.correo);
      this.formTelefono.setValue(this.data.item.telefono);
      this.formCalle.setValue(this.data.item.calle);
      this.formNumExterior.setValue(this.data.item.num_exterior);
      this.formNumInterior.setValue(this.data.item.num_interior);
      this.formColonia.setValue(this.data.item.colonia);
      this.formCiudad.setValue(this.data.item.ciudad);
      this.formEstado.setValue(this.data.item.estado);
      this.formCodigoPostal.setValue(this.data.item.codigo_postal);
    }
  }

  validar_funcion(){
    if(this.seller_customer_id == null){
      this.guardarCliente();
    }else if(this.seller_customer_id != null){
      this.actualizarCliente();
    }
  }

  guardarCliente(){
    this.btn_disabled = true;
    if(this.formNombre.invalid || this.formCorreo.invalid || this.formTelefono.invalid || this.formCalle.invalid
      || this.formNumExterior.invalid || this.formNumInterior.invalid || this.formColonia.invalid
      || this.formCiudad.invalid || this.formEstado.invalid || this.formCodigoPostal.invalid){
        this.btn_disabled = false;
        return;
    }

    this.datos_envio = {
      Nombre: this.formNombre.value,
      Correo: this.formCorreo.value,
      Telefono: this.formTelefono.value,
      Calle: this.formCalle.value,
      NumExterior: this.formNumExterior.value,
      NumInterior: this.formNumInterior.value,
      Colonia: this.formColonia.value,
      Ciudad: this.formCiudad.value,
      Estado: this.formEstado.value,
      CodigoPostal: this.formCodigoPostal.value
    };
    this.loading = true;
    this.spinner = true;
    this.clienteService.guardarCliente(this.datos_envio)
    .pipe(first())
    .subscribe(
      data => {
        if(data["status"] == 200){
          this.mensaje_success = true;
          this.loading = false;
          this.spinner = false;
          this.dialogRef.close();
          this.snackBar.open(data["message"], "OK", {
            duration: 5000,
          });
        }else{
          this.error = data["message"];
          this.loading = false;
          this.spinner = false;
        }
      },
      error => {
        this.error = error;
        this.loading = false;
        this.spinner = false;
    });
  }

  actualizarCliente(){
    this.btn_disabled = true;
    if(this.formNombre.invalid || this.formCorreo.invalid || this.formTelefono.invalid || this.formCalle.invalid
      || this.formNumExterior.invalid || this.formNumInterior.invalid || this.formColonia.invalid
      || this.formCiudad.invalid || this.formEstado.invalid || this.formCodigoPostal.invalid){
        this.btn_disabled = false;
        return;
    }
    this.datos_envio = {
      Nombre: this.formNombre.value,
      Correo: this.formCorreo.value,
      Telefono: this.formTelefono.value,
      Calle: this.formCalle.value,
      NumExterior: this.formNumExterior.value,
      NumInterior: this.formNumInterior.value,
      Colonia: this.formColonia.value,
      Ciudad: this.formCiudad.value,
      Estado: this.formEstado.value,
      CodigoPostal: this.formCodigoPostal.value,
      seller_customer_id: this.seller_customer_id
    };
    this.loading = true;
    this.spinner = true;
    this.clienteService.actualizarCliente(this.datos_envio)
    .pipe(first())
    .subscribe(
      data => {
        if(data["status"] == 200){
          this.mensaje_success = true;
          this.loading = false;
          this.spinner = false;
          this.dialogRef.close();
          this.snackBar.open(data["message"], "OK", {
            duration: 5000,
          });
        }else{
          this.error = data["message"];
          this.loading = false;
          this.spinner = false;
        }
      },
      error => {
        this.error = error;
        this.loading = false;
        this.spinner = false;
    });
  }

}

@Component({
  selector: 'clientes-dialog-4',
  templateUrl: './clientes-dialog-4.html',
})
export class ClientesDialog4 {}

export interface TransactionApi {
  items: TransactionIssue[];
  total_count: number;
}

export interface TransactionIssue {
  created_at: string;
  number: string;
  state: string;
  title: string;
}

/** An example database that the data source uses to retrieve data for the table. */
export class TransactionDatabase {
  constructor(private _httpClient: HttpClient) {}

  getRepoIssues(sort: string, order: string, page: number, filtro: string): Observable<TransactionApi> {

     const href = `${environment.apiUrl}/rmsfe/query_transactions.json`;
    // const href = 'http://localhost:3000/rmsfe/query_entradas.json';
    const requestUrl =
        `${href}?sort=${sort}&order=${order}&page=${page + 1}&keywords=${filtro}`;

    return this._httpClient.get<TransactionApi>(requestUrl);
  }
}


@Component({
  selector: 'accounts-tab-3',
  templateUrl: './accounts-tab-3.html',
  styleUrls: ['./accounts.component.scss']

})
export class AccountsTab3 implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}


@Component({
  selector: 'dialog-account',
  templateUrl: './dialog-account.html',
})
export class DialogAccount {

  guiaForm: FormGroup;
  loading = false;
  submitted = false;
  returnUrl: string;
  error: string;
  la_guia: string;
  mensaje_success = false;
  guiaFormGuia: FormControl;
  formPaqueteria: FormControl;
  paqueteriaFormGuia: FormControl;
  spinner = false;
  entrada_token: string;
  keywords = "";
  otra = false;
  paqueteria: string;

  constructor(
    private formBuilder: FormBuilder,
    private snackBar: MatSnackBar,
    public dialogRef: MatDialogRef<DialogAccount>,
    private entradaService: EntradaService,
    @Inject(MAT_DIALOG_DATA) public data: any
    ){
    if(this.data.token){
      this.entrada_token = this.data.token;
      // console.log("El token es "+this.entrada_token);
    }
  }

  ngOnInit(){
    this.guiaForm = this.formBuilder.group({
      guiaFormGuia: ['', Validators.required],
    });

    this.guiaFormGuia = new FormControl('', [
      Validators.required,
    ]);

    this.formPaqueteria = new FormControl('', [
      Validators.required,
    ]);

    this.paqueteriaFormGuia = new FormControl('', [Validators.required]);
  }

  seleccionar(){
    if(this.formPaqueteria.value == "otro"){
      this.otra = true;
    }else{
      this.otra = false;
    }
  }

  guardarGuia(){
    if (this.guiaFormGuia.invalid || this.formPaqueteria.invalid || (this.otra && this.paqueteriaFormGuia.invalid)){

      return;
    }
    this.loading = true;
    this.spinner = true;

    this.mensaje_success = true;
    this.loading = false;
    this.spinner = false;


    if(this.otra){
      this.paqueteria = this.paqueteriaFormGuia.value;
    }else{
      this.paqueteria = this.formPaqueteria.value;
    }
    this.entradaService.actualizarEntrada(this.entrada_token, this.guiaFormGuia.value, this.paqueteria)
    .pipe(first())
    .subscribe(
      data => {

        if(data.status == 200){
          this.mensaje_success = true;
          this.loading = false;
          this.spinner = false;
        }else{
          this.error = data.body["message"];
          this.loading = false;
          this.spinner = false;
        }
      },
      error => {
        this.error = error;
        this.loading = false;
        this.spinner = false;
   });
  }



}
 // creacion del nuevo tab de usuarios
 @Component({
  selector: 'users-dialog-5',
  templateUrl: './users-dialog-5.html',
})
export class UsersDialog5 {}
@Component({
  selector: 'accounts-tab-5',
  templateUrl: './accounts-tab-5.html',
  styleUrls: ['./accounts.component.scss']

})
export class AccountsTab5  implements OnInit{
  ngOnInit() {
  }
  //crear columnas de las tablas de los usuarios creados
  spinner = false;
  displayedColumnsUser: string[] = [
    'nombre',
    'correo',
    'roles',
    'editar',
    'eliminar'
  ];
  resultsLength = 0;
  entradaDatabase: EntradaDatabase | null;
  data: EntradaIssue[] = [];
  keywords = "";
  isLoadingResults = true;
  isRateLimitReached = false;
  spinner_table = false;
  seller_customer_id = '';
  public btn_editar    = false;
  constructor(public dialog: MatDialog,
  private _httpClient: HttpClient,
  private UserService: UserService,
  private snackBar: MatSnackBar,) { }

  @ViewChild(MatPaginator, {static: false}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: false}) sort: MatSort;
  ngAfterViewInit() {
    this.entradaDatabase = new EntradaDatabase(this._httpClient);
    this.crearTablaUser(this.keywords);
  }
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.keywords = filterValue.trim().toLowerCase();
    this.crearTablaUser(this.keywords);
  }
  abrirModalAlta(){
    this.btn_editar = false;
      const dialogRef2 = this.dialog.open(DialogAltaUser ,{width:'450px', height: 'auto',disableClose: true});

      dialogRef2.afterClosed().subscribe(result => {
        this.spinner = true;
        this.crearTablaUser(this.keywords);
      });
  }
  openEditUser(seller_customer){
    this.btn_editar = true;
    console.log(seller_customer);
    this.UserService.consultarUserFront(seller_customer.id)
    .pipe(first())
    .subscribe(
      data => {
          if(data.status == 200){
            const dialogRef2 = this.dialog.open(DialogAltaUser ,{width:'450px', height: 'auto',disableClose: true, data: {item: data.body.user_customer}});
            dialogRef2.afterClosed().subscribe(result => {
              this.spinner = true;
              this.crearTablaUser(this.keywords);
            });
          }
        },
      error => {
    });
  }
  confirmarEliminarUser(seller_customer_id){
    const dialogRef1 = this.dialog.open(UsersDialog5, {width:'450px', height: 'auto',disableClose: true});

    dialogRef1.afterClosed().subscribe(result => {
      if (result == true){
        this.spinner_table = true;
        this.eliminaruser(seller_customer_id);
      }
    });
  }

  eliminaruser(user_id){
      this.UserService.eliminaruser(user_id)
      .pipe(first())
      .subscribe(
        data => {
          if (data["status"] == 200){
            this.crearTablaUser(this.keywords);
          }
          this.spinner_table = false;
          this.snackBar.open(data["message"], "OK", {
            duration: 7500,
          });
        },
        error => {
          this.spinner_table = false;
          this.snackBar.open("Hubo un error al eliminar al usuario", "OK", {
            duration: 7500,
          });
      });
  }
  crearTablaUser(filtros){
    merge(this.sort.sortChange, this.paginator.page, )
      .pipe(
        startWith({}),
        switchMap(() => {
          this.isLoadingResults = true;
          return this.entradaDatabase!.getListUser(
            this.sort.active, this.sort.direction, this.paginator.pageIndex, filtros);
        }),
        map(data => {
          // Flip flag to show that loading has finished.
          this.isLoadingResults = false;
          this.isRateLimitReached = false;
          this.resultsLength = data.total_count;
          return data.items;
        }),
        catchError(() => {
          this.isLoadingResults = false;
          this.isRateLimitReached = true;
          return observableOf([]);
        })
      ).subscribe(data => this.data = data);
  }


}
//se crea un nuevo formulario para la alta de los usuarios
@Component({
  selector: 'dialog-add-user-tab-5',
  templateUrl: './dialog-add-user-tab-5.html',
})
export class DialogAltaUser {
  userForm: FormGroup;
  formNombre: FormControl;
  formCorreo: FormControl;
  formContrasena: FormControl;
  formContrasenaVerificacion: FormControl;
  formRole: FormControl;
  formIdioma: FormControl;
  roles_seller : [];
  owner_user = false;
  usuario: string;
  mensaje_success = false;
  spinner = false;
  error: string;
  loading = false;
  btn_disabled = false;
  btn_editar   = false;
  modificar_contrasena   = false;
  datos_envio: object;
  seller_customer_id = '';
  user_customer_id: BigInteger;
  constructor(private formBuilder: FormBuilder,
    public dialogRefUser: MatDialogRef<DialogAltaUser>,
    private UserService: UserService,
    private snackBar: MatSnackBar,
    @Inject(MAT_DIALOG_DATA) public data: any){
  }
  ngAfterViewInit() {
    this.get_roles();

  }
  ngOnInit(){
    this.userForm                   = this.formBuilder.group({ });
    this.formNombre                 = new FormControl('', [Validators.required]);
    this.formCorreo                 = new FormControl('', [ Validators.email,Validators.required]);
    this.formContrasena             = new FormControl('', [Validators.required]);
    this.formContrasenaVerificacion = new FormControl('', [Validators.required]);
    this.formRole                   = new FormControl('', [Validators.required]);
    this.formIdioma                 = new FormControl('', [Validators.required]);


    if(this.data != null){
      this.btn_editar = true;

      this.user_customer_id = this.data.item[0].id;
      this.formNombre.setValue(this.data.item[0].name);
      this.formCorreo.setValue(this.data.item[0].email);
      this.formRole.setValue(this.data.item[0].role_id);
      this.formIdioma.setValue(this.data.item[0].idioma);
      if(this.data.item[0].owner){
        this.owner_user = true;
      }else{
        this.owner_user = false;
      }


    }
  }
  static mustMatch(controlName: string, matchingControlName: string) {
    return (formGroup: FormGroup) => {
      const control = formGroup.controls[controlName];
      const matchingControl = formGroup.controls[matchingControlName];

      if (matchingControl.errors && !matchingControl.errors.mustMatch) {
        return;
      }

      // set error on matchingControl if validation fails
      if (control.value !== matchingControl.value) {
        matchingControl.setErrors({ mustMatch: true });
      } else {
        matchingControl.setErrors(null);
      }
      return null;
    };
  }
  generarContrasenaAleatoria(){
    var pass = '';
    var i;
          var str = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ' +
                  'abcdefghijklmnopqrstuvwxyz0123456789@#$';

          for (i = 1; i <= 10; i++) {
              var char = Math.floor(Math.random()
                          * str.length + 1);

              pass += str.charAt(char)
          }
    this.formContrasena.setValue(pass);
    this.formContrasenaVerificacion.setValue(pass);

  }
  validar_funcion(){

    if(!this.btn_editar){
      this.guardarUser();
    }else if(this.btn_editar ){
      this.actualizarUser();
    }
  }
  get_roles(){
    this.UserService.getRolesSeller()
    .pipe(first())
    .subscribe(
      data => {

        if(data["status"] == 200){
          this.roles_seller = data["body"]["data"];

        }else{
          this.roles_seller = [];
        }
      },
      error => {
        this.error = error;
        this.loading = false;
        this.spinner = false;
    });
  }
  guardarUser(){

    this.btn_editar = false;
    if(this.formRole.invalid || this.formIdioma.invalid || this.formNombre.invalid || this.formCorreo.invalid || this.formContrasena.invalid || this.formContrasenaVerificacion.invalid ||(this.formContrasena.value !=this.formContrasenaVerificacion.value)){
        this.btn_disabled = false;
        return;
    }

    this.datos_envio = {
      nombre: this.formNombre.value,
      correo: this.formCorreo.value,
      contrasena: this.formContrasena.value,
      owner_user:this.owner_user,
      role_id : this.formRole.value,
      idioma  : this.formIdioma.value

    };
    this.loading = true;
    this.spinner = true;
    this.UserService.registrarUserFromCuenta(this.datos_envio)
    .pipe(first())
    .subscribe(
      data => {
        if(data["result"] == 200){
          this.mensaje_success = true;
          this.loading = false;
          this.spinner = false;
          this.dialogRefUser.close();
          this.snackBar.open(data["messages"], "Usuario guardado", {
            duration: 5000,
          });
        }else if(data["result"] == 300){
          this.snackBar.open(data["messages"], "Verifique su correo", {
            duration: 5000,
          });
          this.error = data["messages"];
          this.loading = false;
          this.spinner = false;
        }else{
          this.snackBar.open(data["messages"], "Ocurrio un error", {
            duration: 5000,
          });
          this.error = data["messages"];
          this.loading = false;
          this.spinner = false;
        }
      },
      error => {
        this.error = error;
        this.loading = false;
        this.spinner = false;
    });
  }
  resetear_variables(){
    this.formNombre                 = null;
    this.formCorreo                 = null;
    this.formContrasena             = null;
    this.formContrasenaVerificacion = null;
    this.formRole                   = null;
    this.formIdioma                 = null;
  }
  actualizarUser(){
    this.btn_disabled = true;

    if(this.formRole.invalid || this.formIdioma.invalid || this.formNombre.invalid || this.formCorreo.invalid || (this.modificar_contrasena && (this.formContrasena.invalid || this.formContrasenaVerificacion.invalid)) ){
        this.btn_disabled = false;
        return;
    }
    this.datos_envio = {
      nombre               : this.formNombre.value,
      correo               : this.formCorreo.value,
      contrasena           : this.formContrasena.value,
      modificar_contrasena : this.modificar_contrasena,
      user_customer_id     : this.user_customer_id,
      owner_user           : this.owner_user,
      role_id              : this.formRole.value,
      idioma               : this.formIdioma.value
    };
    this.loading = true;
    this.spinner = true;
    this.UserService.actualizarUserFront(this.datos_envio)
    .pipe(first())
    .subscribe(
      data => {
        if(data["status"] == 200){
          this.mensaje_success = true;
          this.loading = false;
          this.spinner = false;
          this.dialogRefUser.close();
          this.snackBar.open(data["messages"], "OK", {
            duration: 5000,
          });
        }else if(data["status"] == 300){
          this.snackBar.open(data["messages"], "Verifique su correo", {
            duration: 5000,
          });
          this.error = data["messages"];
          this.loading = false;
          this.spinner = false;
        }else{
          this.snackBar.open(data["messages"], "Ocurrio un error", {
            duration: 5000,
          });
          this.error = data["messages"];
          this.loading = false;
          this.spinner = false;
        }
      },
      error => {
        this.error = error;
        this.loading = false;
        this.spinner = false;
    });
  }


}
//! CREACION  DEL TAB PARA GESTIONAR LOS ROLES Y LOS PERSMISOS  A LOS USUARIOS
@Component({
  selector: 'users-dialog-6',
  templateUrl: './users-dialog-6.html',
})

export class UsersDialog6 {}
@Component({
  selector: 'accounts-tab-6',
  templateUrl: './accounts-tab-6.html',
  styleUrls: ['./accounts.component.scss']

})
export class AccountsTab6  implements OnInit{
  ngOnInit() {
  }
  //crear columnas de las tablas de los usuarios creados
  spinner = false;
  displayedColumnsRole: string[] = [
    'nombre',
    'permisos',
    'editar',
    'eliminar'
  ];
  resultsLength = 0;
  entradaDatabase: EntradaDatabase | null;
  data: EntradaIssue[] = [];
  keywords = "";
  isLoadingResults = true;
  isRateLimitReached = false;
  spinner_table = false;
  seller_customer_id = '';
  public btn_editar    = false;
  constructor(public dialog: MatDialog,
  private _httpClient: HttpClient,
  private UserService: UserService,
  private snackBar: MatSnackBar,) { }

  @ViewChild(MatPaginator, {static: false}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: false}) sort: MatSort;
  ngAfterViewInit() {
    this.entradaDatabase = new EntradaDatabase(this._httpClient);
    this.crearTablaRole(this.keywords);
  }
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.keywords = filterValue.trim().toLowerCase();
    this.crearTablaRole(this.keywords);
  }
  abrirModalAlta(){
    this.btn_editar = false;
      const dialogRef2 = this.dialog.open(DialogAltaRoles ,{width:'450px', height: 'auto',disableClose: true});

      dialogRef2.afterClosed().subscribe(result => {
        this.spinner = true;
        this.crearTablaRole(this.keywords);
      });
  }
  openEditRole(data_role){
    this.btn_editar = true;
    this.UserService.consultarRoles(data_role.id)
    .pipe(first())
    .subscribe(
      data => {
          if(data.status == 200){
            const dialogRef2 = this.dialog.open(DialogAltaRoles ,{width:'450px', height: 'auto',disableClose: true, data: {item: data.body.user_customer}});
            dialogRef2.afterClosed().subscribe(result => {
              this.spinner = true;
              this.crearTablaRole(this.keywords);
            });
          }
        },
      error => {
    });
  }
  openPermisosModal(data_role){


    this.UserService.consultar_permisos(data_role.id)
    .pipe(first())
    .subscribe(
      data => {
          if(data.status == 200){

            const dialogRef2 = this.dialog.open(DialogPermisosRoles ,{width:'450px', height: 'auto',disableClose: true, data: {item: data.body.data,role_id:data_role.id}});
            dialogRef2.afterClosed().subscribe(result => {
              this.spinner = true;

            });
          }
        },
      error => {
    });
  }
  confirmarEliminarRole(role_id){
    const dialogRef1 = this.dialog.open(UsersDialog6, {width:'450px', height: 'auto',disableClose: true});

    dialogRef1.afterClosed().subscribe(result => {
      if (result == true){
        this.spinner_table = true;
        this.eliminarRole(role_id);
      }
    });
  }

  eliminarRole(role_id){
      this.UserService.eliminarRole(role_id)
      .pipe(first())
      .subscribe(
        data => {
          if (data["status"] == 200){
            this.crearTablaRole(this.keywords);
            this.spinner_table = false;
            this.snackBar.open(data["message"], "OK", {
              duration: 7500,
            });
          }else{
            this.spinner_table = false;
            this.snackBar.open(data["message"], "OK", {
              duration: 7500,
            });
          }

        },
        error => {
          this.spinner_table = false;
          this.snackBar.open("Hubo un error al eliminar al usuario", "OK", {
            duration: 7500,
          });
      });
  }
  crearTablaRole(filtros){
    merge(this.sort.sortChange, this.paginator.page, )
      .pipe(
        startWith({}),
        switchMap(() => {
          this.isLoadingResults = true;
          return this.entradaDatabase!.getListRole(
            this.sort.active, this.sort.direction, this.paginator.pageIndex, filtros);
        }),
        map(data => {
          // Flip flag to show that loading has finished.
          this.isLoadingResults = false;
          this.isRateLimitReached = false;
          this.resultsLength = data.total_count;
          return data.items;
        }),
        catchError(() => {
          this.isLoadingResults = false;
          this.isRateLimitReached = true;
          return observableOf([]);
        })
      ).subscribe(data => this.data = data);
  }


}
//se crea un nuevo formulario para la alta de los usuarios
@Component({
  selector: 'dialog-add-user-tab-6',
  templateUrl: './dialog-add-user-tab-6.html',
})
export class DialogAltaRoles {
  userForm: FormGroup;
  formNombre: FormControl;
  formCorreo: FormControl;
  formContrasena: FormControl;
  formContrasenaVerificacion: FormControl;
  owner_user = false;
  usuario: string;
  mensaje_success = false;
  spinner = false;
  error: string;
  loading = false;
  btn_disabled = false;
  btn_editar   = false;
  modificar_contrasena   = false;
  datos_envio: object;
  seller_customer_id = '';
  role_id: BigInteger;
  constructor(private formBuilder: FormBuilder,
    public dialogRefRoles: MatDialogRef<DialogAltaRoles>,
    public dialogRefPermisos: MatDialogRef<DialogPermisosRoles>,
    private UserService: UserService,
    private snackBar: MatSnackBar,
    @Inject(MAT_DIALOG_DATA) public data: any){
  }

  ngOnInit(){
    this.userForm = this.formBuilder.group({ });
    this.formNombre = new FormControl('', [Validators.required]);
    this.formCorreo = new FormControl('', [ Validators.email,Validators.required]);
    this.formContrasena = new FormControl('', [Validators.required]);
    this.formContrasenaVerificacion = new FormControl('', [Validators.required] );


    if(this.data != null){
      this.btn_editar = true;

      this.role_id = this.data.item[0].id;
      this.formNombre.setValue(this.data.item[0].descripcion);



    }
  }
  static mustMatch(controlName: string, matchingControlName: string) {
    return (formGroup: FormGroup) => {
      const control = formGroup.controls[controlName];
      const matchingControl = formGroup.controls[matchingControlName];

      if (matchingControl.errors && !matchingControl.errors.mustMatch) {
        return;
      }

      // set error on matchingControl if validation fails
      if (control.value !== matchingControl.value) {
        matchingControl.setErrors({ mustMatch: true });
      } else {
        matchingControl.setErrors(null);
      }
      return null;
    };
  }
  generarContrasenaAleatoria(){
    var pass = '';
    var i;
          var str = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ' +
                  'abcdefghijklmnopqrstuvwxyz0123456789@#$';

          for (i = 1; i <= 10; i++) {
              var char = Math.floor(Math.random()
                          * str.length + 1);

              pass += str.charAt(char)
          }
    this.formContrasena.setValue(pass);
    this.formContrasenaVerificacion.setValue(pass);

  }
  validar_funcion(){
    if(!this.btn_editar){
      this.guardarRole();
    }else if(this.btn_editar ){
      this.actualizarRole();
    }
  }

  guardarRole(){

    this.btn_editar = false;
    if(this.formNombre.invalid ){
        this.btn_disabled = false;
        return;
    }

    this.datos_envio = {
      nombre: this.formNombre.value

    };
    this.loading = true;
    this.spinner = true;
    this.UserService.registrarRole(this.datos_envio)
    .pipe(first())
    .subscribe(
      data => {
        if(data["result"] == 200){
          this.mensaje_success = true;
          this.loading = false;
          this.spinner = false;
          this.dialogRefRoles.close();
          this.snackBar.open(data["messages"], "Role guardado", {
            duration: 1000,
          });
        }else if(data["result"] == 300){
          this.snackBar.open(data["messages"], "Verifique su correo", {
            duration: 2000,
          });
          this.error = data["messages"];
          this.loading = false;
          this.spinner = false;
        }else{
          this.snackBar.open(data["messages"], "Ocurrio un error", {
            duration: 2000,
          });
          this.error = data["messages"];
          this.loading = false;
          this.spinner = false;
        }
      },
      error => {
        this.error = error;
        this.loading = false;
        this.spinner = false;
    });
  }
  resetear_variables(){
    this.formNombre = null;
    this.formCorreo = null;
    this.formContrasena = null;
    this.formContrasenaVerificacion = null;
  }
  actualizarRole(){
    this.btn_disabled = true;

    if(this.formNombre.invalid){
        this.btn_disabled = false;
        return;
    }
    this.datos_envio = {
      nombre  : this.formNombre.value,
      role_id : this.role_id,
    };
    this.loading = true;
    this.spinner = true;
    this.UserService.actualizarRole(this.datos_envio)
    .pipe(first())
    .subscribe(
      data => {
        if(data["status"] == 200){
          this.mensaje_success = true;
          this.loading = false;
          this.spinner = false;
          this.dialogRefRoles.close();
          this.snackBar.open(data["messages"], "OK", {
            duration: 5000,
          });
        }else if(data["status"] == 300){
          this.snackBar.open(data["messages"], "Verifique su correo", {
            duration: 2000,
          });
          this.error = data["messages"];
          this.loading = false;
          this.spinner = false;
        }else{
          this.snackBar.open(data["messages"], "Ocurrio un error", {
            duration: 2000,
          });
          this.error = data["messages"];
          this.loading = false;
          this.spinner = false;
        }
      },
      error => {
        this.error = error;
        this.loading = false;
        this.spinner = false;
    });
  }


}
@Component({
  selector: 'dialog-add-permisos-tab-6',
  templateUrl: './dialog-add-permisos-tab-6.html',
})
export class DialogPermisosRoles {
  userForm                   : FormGroup;
  formNombre                 : FormControl;
  formCorreo                 : FormControl;
  formContrasena             : FormControl;
  formContrasenaVerificacion : FormControl;
  owner_user                 = false;
  usuario                    : string;
  mensaje_success            = false;
  spinner                    = false;
  error                      : string;
  loading                    = false;
  btn_disabled               = false;
  btn_editar                 = false;
  modificar_contrasena       = false;
  datos_envio                : object;
  seller_customer_id         = '';
  role_id                    : BigInteger;
  permisos                   : [];
  press                      : false;
  key                        : null;
  checkboxList               : {};
  list                       : [];
  constructor(private formBuilder: FormBuilder,
    public dialogRefRoles: MatDialogRef<DialogAltaRoles>,
    public dialogRefPermisos: MatDialogRef<DialogPermisosRoles>,
    private UserService: UserService,
    private snackBar: MatSnackBar,
    @Inject(MAT_DIALOG_DATA) public data: any){
  }

  ngOnInit(){
    this.userForm = this.formBuilder.group({ });
    this.formNombre = new FormControl('', [Validators.required]);
    this.formCorreo = new FormControl('', [ Validators.email,Validators.required]);
    this.formContrasena = new FormControl('', [Validators.required]);
    this.formContrasenaVerificacion = new FormControl('', [Validators.required] );


    if(this.data != null){
      this.btn_editar = true;
      this.permisos = this.data.item;
      this.role_id  = this.data.role_id;



    }
  }
  static mustMatch(controlName: string, matchingControlName: string) {
    return (formGroup: FormGroup) => {
      const control = formGroup.controls[controlName];
      const matchingControl = formGroup.controls[matchingControlName];

      if (matchingControl.errors && !matchingControl.errors.mustMatch) {
        return;
      }

      // set error on matchingControl if validation fails
      if (control.value !== matchingControl.value) {
        matchingControl.setErrors({ mustMatch: true });
      } else {
        matchingControl.setErrors(null);
      }
      return null;
    };
  }
  generarContrasenaAleatoria(){
    var pass = '';
    var i;
          var str = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ' +
                  'abcdefghijklmnopqrstuvwxyz0123456789@#$';

          for (i = 1; i <= 10; i++) {
              var char = Math.floor(Math.random()
                          * str.length + 1);

              pass += str.charAt(char)
          }
    this.formContrasena.setValue(pass);
    this.formContrasenaVerificacion.setValue(pass);

  }

  validar_function_permission(){

    this.guardarPermisos();

  }

  guardarPermisos(){



    this.datos_envio = {
      permisos : this.permisos,
      role_id  : this.role_id

    };
    this.loading = true;
    this.spinner = true;
    this.UserService.registrar_permisos(this.datos_envio)
    .pipe(first())
    .subscribe(
      data => {
        if(data["result"] == 200){
          this.mensaje_success = true;
          this.loading = false;
          this.spinner = false;
          this.dialogRefRoles.close();
          this.snackBar.open(data["messages"], "Permisos guardado", {
            duration: 1000,
          });
        }else if(data["result"] == 300){
          this.snackBar.open(data["messages"], "Verifique su correo", {
            duration: 2000,
          });
          this.error = data["messages"];
          this.loading = false;
          this.spinner = false;
        }else{
          this.snackBar.open(data["messages"], "Ocurrio un error", {
            duration: 2000,
          });
          this.error = data["messages"];
          this.loading = false;
          this.spinner = false;
        }
      },
      error => {
        this.error = error;
        this.loading = false;
        this.spinner = false;
    });
  }
  resetear_variables(){
    this.formNombre = null;
    this.formCorreo = null;
    this.formContrasena = null;
    this.formContrasenaVerificacion = null;
  }
  actualizarPermisos(){
    this.btn_disabled = true;

    if(this.formNombre.invalid){
        this.btn_disabled = false;
        return;
    }
    this.datos_envio = {
      nombre  : this.formNombre.value,
      role_id : this.role_id,
    };
    this.loading = true;
    this.spinner = true;
    this.UserService.actualizarRole(this.datos_envio)
    .pipe(first())
    .subscribe(
      data => {
        if(data["status"] == 200){
          this.mensaje_success = true;
          this.loading = false;
          this.spinner = false;
          this.dialogRefRoles.close();
          this.snackBar.open(data["messages"], "OK", {
            duration: 5000,
          });
        }else if(data["status"] == 300){
          this.snackBar.open(data["messages"], "Verifique su correo", {
            duration: 2000,
          });
          this.error = data["messages"];
          this.loading = false;
          this.spinner = false;
        }else{
          this.snackBar.open(data["messages"], "Ocurrio un error", {
            duration: 2000,
          });
          this.error = data["messages"];
          this.loading = false;
          this.spinner = false;
        }
      },
      error => {
        this.error = error;
        this.loading = false;
        this.spinner = false;
    });
  }
}

export interface ClaveSat {
  clave_prod_serv: string;
  descripcion: string;
  palabras_similares: string;
  material_peligroso: string;
  fecha_inicio_vigencia: string;
  fecha_fin_vigencia: string;
  created_at: string;
}

@Component({
  selector: 'dialog-add-box',
  templateUrl: './dialog-add-box.html',
})
export class DialogAltaBox {
  boxForm: FormGroup;
  formNombre: FormControl;
  formCodigo: FormControl;
  formAlto: FormControl;
  formLargo: FormControl;
  formAncho: FormControl;
  formTipoEmpaque: FormControl;
  visible = false;
  mensaje_success = false;
  current_user: any;
  spinner = false;
  error: string;
  loading = false;
  spinner_table = false;
  btn_disabled = false;
  datos_envio: object;
  fulfillment_id: any;
  box_id: '';
  constructor(private formBuilder: FormBuilder,
    public dialogRef: MatDialogRef<DialogAltaBox>,
    private clienteService: ClienteService,
    private snackBar: MatSnackBar,
    public dialog: MatDialog,
    private authenticationService: AuthenticationService,
    @Inject(MAT_DIALOG_DATA) public data: any){
  }

  ngOnInit(){
    this.boxForm = this.formBuilder.group({ });
    this.formNombre = new FormControl('', [Validators.required]);
    this.formCodigo = new FormControl('', [Validators.required]);
    this.formAlto = new FormControl('', [Validators.required]);
    this.formLargo = new FormControl('', [Validators.required]);
    this.formAncho = new FormControl('', [Validators.required]);
    this.formTipoEmpaque = new FormControl('', [Validators.required]);

    this.current_user = this.authenticationService.currentUserValue
    this.fulfillment_id = this.current_user.fulfillment_id

    if(this.data != null){

      this.box_id = this.data.item.id;
      this.formNombre.setValue(this.data.item.nombre);
      this.formCodigo.setValue(this.data.item.codigo);
      this.formAlto.setValue(this.data.item.alto);
      this.formLargo.setValue(this.data.item.largo);
      this.formAncho.setValue(this.data.item.ancho);
      this.formTipoEmpaque.setValue(this.data.item.tipo_empaque);

      if(this.data.item.visible){
        this.visible = true;
      }else{
        this.visible = false;
      }

    }
  }

  validar_funcion_caja(){
    if(this.box_id == null){
      this.guardarCaja();
    }else if(this.box_id != null){
      this.actualizarCaja();
    }
  }

  guardarCaja(){
    this.btn_disabled = true;
    if(this.formNombre.invalid || this.formCodigo.invalid || this.formAlto.invalid || this.formLargo.invalid
      || this.formAncho.invalid || this.formTipoEmpaque.invalid){
        this.btn_disabled = false;
        return;
    }

    this.datos_envio = {
      Nombre: this.formNombre.value,
      Codigo: this.formCodigo.value,
      Alto: this.formAlto.value,
      Largo: this.formLargo.value,
      Ancho: this.formAncho.value,
      Visible: this.visible,
      Fulfillment_id : this.fulfillment_id,
      TipoEmpaque: this.formTipoEmpaque.value,
    };
    this.loading = true;
    this.spinner = true;
    this.clienteService.guardarCaja(this.datos_envio)
    .pipe(first())
    .subscribe(
      data => {
        if(data["status"] == 200){
          this.mensaje_success = true;
          this.loading = false;
          this.spinner = false;
          this.dialogRef.close();
          this.snackBar.open(data["message"], "OK", {
            duration: 5000,
          });
        }else{
          this.error = data["message"];
          this.loading = false;
          this.spinner = false;
        }
      },
      error => {
        this.error = error;
        this.loading = false;
        this.spinner = false;
    });
  }

  actualizarCaja(){
    this.btn_disabled = true;
    if(this.formNombre.invalid || this.formCodigo.invalid || this.formAlto.invalid || this.formLargo.invalid
      || this.formAncho.invalid || this.formTipoEmpaque.invalid){
        this.btn_disabled = false;
        return;
    }
    this.datos_envio = {
      Nombre: this.formNombre.value,
      Codigo: this.formCodigo.value,
      Alto: this.formAlto.value,
      Largo: this.formLargo.value,
      Ancho: this.formAncho.value,
      Visible: this.visible,
      TipoEmpaque: this.formTipoEmpaque.value,
      Box_id: this.box_id
    };
    this.loading = true;
    this.spinner = true;
    this.clienteService.actualizarCaja(this.datos_envio)
    .pipe(first())
    .subscribe(
      data => {
        if(data["status"] == 200){
          this.mensaje_success = true;
          this.loading = false;
          this.spinner = false;
          this.dialogRef.close();
          this.snackBar.open(data["message"], "OK", {
            duration: 5000,
          });
        }else{
          this.error = data["message"];
          this.loading = false;
          this.spinner = false;
        }
      },
      error => {
        this.error = error;
        this.loading = false;
        this.spinner = false;
    });
  }

}

@Component({
  selector: 'clientes-dialog-5',
  templateUrl: './clientes-dialog-5.html',
})
export class ClientesDialog5 {}


  //! TERMINA CREACION DE FUNCION DEL TAB DE ROLES Y PERSMISOS

   //temrina  la creacion del componenete para la alta de usuarios

//! INICIA CREACION DE FUNCION DEL TAB DE SELLER CREDENTIALS

@Component({
  selector: 'accounts-tab-8',
  templateUrl: './accounts-tab-8.html',
  styleUrls: ['./accounts.component.scss']

})
export class AccountsTab8 implements OnInit {
  spinner_table = false;
  displayedColumnsCredential: string[] = [
    'usuario',
    'password',
    'channel',
    'warehouse',
    'editar',
    'eliminar'
  ];
  data: any[] = [];
  resultsLength = 0;
  keywords = "";
  current_user: any;
  entradaDatabase    : EntradaDatabase | null;
  isLoadingResults   = true;
  isRateLimitReached = false;


  constructor(
    private formBuilder: FormBuilder,
    private _httpClient: HttpClient,
    public dialog: MatDialog,
    private snackBar: MatSnackBar,
    private authenticationService: AuthenticationService,
    private credentialService: CredentialService
  ) { }

  @ViewChild(MatPaginator, {static: false}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: false}) sort: MatSort;

  ngAfterViewInit() {
    this.entradaDatabase = new EntradaDatabase(this._httpClient);
    this.crearTablaCredential(this.keywords);
  }

  ngOnInit() {
    this.asignarDatos();
  }

  asignarDatos(){
    this.current_user = this.authenticationService.currentUserValue;
  }

  validar_roles(clave_modulo){
    return this.authenticationService.validar_roles(clave_modulo,this.current_user.permisos);
  }

  crearTablaCredential(filtros){
    merge(this.sort.sortChange, this.paginator.page, )
      .pipe(
        startWith({}),
        switchMap(() => {
          this.isLoadingResults = true;
          return this.entradaDatabase!.getListCredentials(
            this.sort.active, this.sort.direction, this.paginator.pageIndex, filtros);
        }),
        map(data => {
          // Flip flag to show that loading has finished.
          this.isLoadingResults = false;
          this.isRateLimitReached = false;
          this.resultsLength = data.total_count;
          this.spinner_table = false;
          return data.items;
        }),
        catchError(() => {
          this.isLoadingResults = false;
          this.isRateLimitReached = true;
          return observableOf([]);
        })
      ).subscribe(data => this.data = data);
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.keywords = filterValue;
    this.crearTablaCredential(this.keywords);
  }

  abrirModalAlta() {
    const dialogRef = this.dialog.open(DialogAltaCredential, {
      width: '450px',
      height: 'auto',
      disableClose: true,
      data: { item: null }
    });
    dialogRef.afterClosed().subscribe(result => {
      this.spinner_table = true;
      this.crearTablaCredential(this.keywords);
    });
  }

  openEditCredential(credential) {
    const dialogRef = this.dialog.open(DialogAltaCredential, {
      width: '450px',
      height: 'auto',
      disableClose: true,
      data: { item: credential }
    });
    dialogRef.afterClosed().subscribe(result => {
      this.spinner_table = true;
      this.crearTablaCredential(this.keywords);
    });
  }

  confirmarEliminarCredential(credential_id) {
    // Implementar confirmación de eliminación
    if (confirm('¿Está seguro de que desea eliminar esta credencial?')) {
      this.eliminarCredential(credential_id);
    }
  }

  eliminarCredential(credential_id) {
    // Aquí iría la llamada al servicio para eliminar la credencial
    this.spinner_table = true;
    
    this.credentialService.eliminarCredential(credential_id)
    .pipe(first())
    .subscribe(
      data => {
        if(data && (data.status === 200 || data.status === 201)) {
          this.snackBar.open(data.message || 'Credencial eliminada exitosamente', 'OK', {
            duration: 5000,
          });
        } else {
          this.snackBar.open(data.message || 'Error al eliminar la credencial', 'OK', {
            duration: 5000,
          });
        }
        this.crearTablaCredential(this.keywords);
      },
      error => {
        this.snackBar.open('Error al eliminar la credencial', 'OK', {
          duration: 5000,
        });
        this.spinner_table = false;
      }
    );
  }
}

@Component({
  selector: 'dialog-add-credential-tab-8',
  templateUrl: './dialog-add-credential-tab-8.html',
})
export class DialogAltaCredential {
  credentialForm: FormGroup;
  fromChannel: FormControl;
  formUsuario: FormControl;
  formPassword: FormControl;
  formAlmacen: FormControl;
  mensaje_success = false;
  spinner = false;
  error: string;
  loading = false;
  loadingAlmacenes = false;
  btn_disabled = false;
  new_credential: object;
  credential_id: string;
  almacenes = [];
  channel = [
    { name: 'Dropi', value: 'dropi' },
    { name: 'Tiui', value: 'tiui' }
  ];
  token: string = '';
  userId: number = 0;
  tokenExpiration: string = '';
  mostrarAlmacen = false;
  tiuiConexionVerificada = false;

  constructor(
    private formBuilder: FormBuilder,
    public dialogRef: MatDialogRef<DialogAltaCredential>,
    private snackBar: MatSnackBar,
    private credentialService: CredentialService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

async ngOnInit() {
    this.credentialForm = this.formBuilder.group({});
    this.formUsuario = new FormControl('', [Validators.required]);
    this.formPassword = new FormControl('', [Validators.required]);
    this.formAlmacen = new FormControl('', [Validators.required]);
    this.fromChannel = new FormControl('', [Validators.required]);
    
    // Suscripción para detectar cambios en el canal seleccionado
    this.fromChannel.valueChanges.subscribe(value => {
      // Cuando cambia el canal, reiniciamos las banderas de verificación
      if (value === 'tiui') {
        this.tiuiConexionVerificada = false;
      }
      this.mostrarAlmacen = false;
      this.almacenes = [];
      this.formAlmacen.setValue(null);
    });

      if (this.data && this.data.item) {
      this.credential_id = this.data.item.id;
      this.formUsuario.setValue(this.data.item.user);
      this.formPassword.setValue(this.data.item.password);
      this.fromChannel.setValue(this.data.item.channel);
      
      if (this.data.item.token) {
        this.token = this.data.item.token;
      }
      if (this.data.item.userId) {
        this.userId = this.data.item.userId;
      }
      if (this.data.item.tokenExpiration) {
        this.tokenExpiration = this.data.item.tokenExpiration;
      }
      
      // Si estamos editando una credencial de Tiui, la consideramos ya verificada
      if (this.data.item.channel === 'tiui') {
        this.tiuiConexionVerificada = true;
      }      await setTimeout(async () => {
        // Solo para el canal Dropi necesitamos obtener los almacenes
        if (this.fromChannel.value === 'dropi') {
          const currentWarehouseValue = this.data.item.warehouse;
          
          await this.obtenerAlmacenes();
          
          const checkWarehousesInterval = setInterval(() => {
            if (this.almacenes && this.almacenes.length > 0) {
              if (currentWarehouseValue) {
                let warehouse = this.almacenes.find(almacen => almacen.name === currentWarehouseValue);
                let warehouseNameText = warehouse ? warehouse.value : '';
                this.formAlmacen.setValue(warehouseNameText);
              }
              clearInterval(checkWarehousesInterval);
            }
          }, 500);
          
          setTimeout(() => {
            clearInterval(checkWarehousesInterval);
          }, 5000);
        }
      }, 500);
    }

  }

  validar_funcion() {
    if (this.credential_id == null) {
      this.guardarCredential();
    } else {
      this.actualizarCredential();
    }
  }
  
  verificarConexionTiui() {
    if (!this.formUsuario.value || !this.formPassword.value) {
      this.error = "Complete el usuario y contraseña antes de verificar la conexión";
      return;
    }

    this.error = null;
    this.loadingAlmacenes = true;
    // Reiniciamos la bandera de conexión verificada
    this.tiuiConexionVerificada = false;
    
    const credentials = {
      email: this.formUsuario.value,
      password: this.formPassword.value
    };
    
    this.credentialService.loginTiui(credentials)
    .subscribe(
      response => {
        this.loadingAlmacenes = false;
        if (response && response.accessToken) {
          this.token = response.accessToken;
          this.userId = response.user.usuarioId;
          this.tokenExpiration = response.expireInSeconds || '';
          // Marcamos que la conexión fue exitosa
          this.tiuiConexionVerificada = true;
          this.snackBar.open("Conexión con Tiui exitosa", "OK", {
            duration: 3000,
          });
        } else {
          this.tiuiConexionVerificada = false;
          this.error = "Error en las credenciales. Verifique usuario y contraseña.";
        }
      },
      error => {
        console.error("Error en login:", error);
        this.tiuiConexionVerificada = false;
        this.error = "Error al iniciar sesión en Tiui: " + (error.message || "Error desconocido");
        this.loadingAlmacenes = false;
      }
    );
  }

  async obtenerAlmacenes() {
    this.almacenes = [];
    this.mostrarAlmacen = false;
    this.formAlmacen.setValue(null);
    if (!this.formUsuario.value || !this.formPassword.value || !this.fromChannel.value) {
      this.error = "Complete el usuario, contraseña y canal antes de obtener almacenes";
      return;
    }

    this.error = null;
    this.loadingAlmacenes = true;
    
    const credentials = {
      email: this.formUsuario.value,
      password: this.formPassword.value
    };
    
    this.credentialService.loginDropi(credentials)
    .subscribe(
      response => {
        if (response && response.token && response.userId) {
          this.token = response.token;
          this.userId = response.userId;
          this.tokenExpiration = response.tokenExpiration;

          this.credentialService.getDropiWarehouses(credentials, this.userId, this.token)
          .subscribe(
            warehouses => {
              this.loadingAlmacenes = false;
              if (warehouses && warehouses.success && warehouses.data && warehouses.data.length > 0) {
                this.almacenes = warehouses.data.map(wh => {
                  return { name: wh.name, value: wh.id.toString() };
                });
                this.mostrarAlmacen = true;
                this.formAlmacen.setValue(null);
                this.snackBar.open("Almacenes obtenidos correctamente", "OK", {
                  duration: 3000,
                });
              } else {
                this.error = "No se encontraron almacenes para este usuario";
                this.loadingAlmacenes = false;
              }
            },
            error => {
              console.error("Error al obtener almacenes:", error);
              if (error.status === 401) {
                this.error = "Error de autorización. Token inválido o expirado.";
              } else if (error.status === 404) {
                this.error = "No se encontraron almacenes para este usuario";
              } else {
                this.error = "Error al obtener los almacenes: " + (error.message || "Error desconocido");
              }
              this.loadingAlmacenes = false;
            }
          );
        } else {
          this.error = "Error en las credenciales. Verifique usuario y contraseña.";
          this.loadingAlmacenes = false;
        }
      },
      error => {
        console.error("Error en login:", error);
        let errores = "";
        if(error.length > 0) {
          errores = error;
        }
        this.error = "Error al iniciar sesión en Dropi: "+ (errores || "Error desconocido");
        this.loadingAlmacenes = false;
      }
    );
  }

  guardarCredential() {
    this.btn_disabled = true;
    if (this.formUsuario.invalid || this.formPassword.invalid || this.fromChannel.invalid) {
      this.btn_disabled = false;
      return;
    }
    
    // Para el canal Dropi se requiere el almacén
    if (this.fromChannel.value === 'dropi' && this.formAlmacen.invalid) {
      this.btn_disabled = false;
      return;
    }
    
    // Para el canal Tiui se requiere verificación exitosa
    if (this.fromChannel.value === 'tiui' && !this.tiuiConexionVerificada) {
      this.error = "Debe verificar la conexión con Tiui antes de guardar";
      this.btn_disabled = false;
      return;
    }
   
    let warehouse = null;
    let warehouseName = '';
    let warehouseId = '';
    
    if (this.fromChannel.value === 'dropi') {
      warehouse = this.almacenes.find(almacen => almacen.value === this.formAlmacen.value);
      warehouseName = warehouse ? warehouse.name : '';
      warehouseId = this.formAlmacen.value;
    }

    this.new_credential = {
      user: this.formUsuario.value,
      password: this.formPassword.value,
      channel: this.fromChannel.value,
      warehouse: warehouseName,
      warehouse_id: warehouseId,
      channel_user_id: this.userId,
      token: this.token,
      token_expiration: this.tokenExpiration
    };

    this.loading = true;
    this.spinner = true;
    this.credentialService.guardarCredential(this.new_credential)
    .pipe(first())
    .subscribe(
      data => {
        if(data.code == 200 || data.code == 201){
          this.mensaje_success = true;
          this.loading = false;
          this.spinner = false;
          this.dialogRef.close();
          this.snackBar.open(data.message || "Credencial creada exitosamente", "OK", {
            duration: 5000,
          });
        } else {
          this.error = data.message || "Error al crear la credencial";
          if (data.errors && data.errors.length > 0) {
            this.error += ": " + data.errors;
          }
          this.loading = false;
          this.spinner = false;
          this.btn_disabled = false;
        }
      },
      error => {
        console.error("Error al crear la credencial:", error);
        this.error = "Error al crear la credencial";
        this.loading = false;
        this.spinner = false;
        this.btn_disabled = false;
    });
    
  }

  actualizarCredential() {
    this.btn_disabled = true;
    if (this.formUsuario.invalid || this.formPassword.invalid || this.fromChannel.invalid) {
      this.btn_disabled = false;
      return;
    }
    
    // Para el canal Dropi se requiere el almacén
    if (this.fromChannel.value === 'dropi' && this.formAlmacen.invalid) {
      this.btn_disabled = false;
      return;
    }
    
    // Para el canal Tiui se requiere verificación exitosa
    if (this.fromChannel.value === 'tiui' && !this.tiuiConexionVerificada) {
      this.error = "Debe verificar la conexión con Tiui antes de actualizar";
      this.btn_disabled = false;
      return;
    }
    
    let warehouse = null;
    let warehouseName = '';
    let warehouseId = '';
    
    if (this.fromChannel.value === 'dropi') {
      warehouse = this.almacenes.find(almacen => almacen.value === this.formAlmacen.value);
      warehouseName = warehouse ? warehouse.name : '';
      warehouseId = this.formAlmacen.value;
    }
    
    this.new_credential = {
      id: this.credential_id,
      user: this.formUsuario.value,
      password: this.formPassword.value,
      channel: this.fromChannel.value,
      warehouse: warehouseName,
      warehouse_id: warehouseId,
      channel_user_id: this.userId,
      token: this.token,
      token_expiration: this.tokenExpiration
    };

    this.loading = true;
    this.spinner = true;
    
    this.credentialService.actualizarCredential(this.new_credential)
    .pipe(first())
    .subscribe(
      data => {
        if(data.code == 200 || data.code == 201){
          this.mensaje_success = true;
          this.loading = false;
          this.spinner = false;
          this.dialogRef.close();
          this.snackBar.open(data.message || 'Credencial actualizada exitosamente', "OK", {
            duration: 5000,
          });
        } else {
          this.error = data.message || "Error al actualizar la credencial";
          if (data.errors && data.errors.length > 0) {
            this.error += ": " + data.errors.join(", ");
          }
          this.loading = false;
          this.spinner = false;
          this.btn_disabled = false;
        }
      },
      error => {
        console.error("Error al actualizar la credencial:", error);
        this.error = "Error al actualizar la credencial";
        this.loading = false;
        this.spinner = false;
        this.btn_disabled = false;
    });
  }
}
